import imageMapResize from 'image-map-resizer'
import Map from '../modules/Map'
import Helpers from '../modules/Helpers'

if (document.getElementsByClassName('owners-location__map').length) {
    const map = new Map('map', { center: [50.102, -5.275], zoom: 12 })
    const wkt = document.getElementById('map').getAttribute('data-shape')
    map.addShape(wkt)
    map.fitShapes()
}

const imageEl = document.getElementById('owners-cms-block-map__image')
if (typeof (imageEl) !== 'undefined' && imageEl !== null) {
    imageMapResize()

    const imageSrc = imageEl.src
    const regions = {
        'owners-cms-block-map__cornwall': '/media/owners/02-Cornwall.jpg',
        'owners-cms-block-map__devon': '/media/owners/03-Devon.jpg',
        'owners-cms-block-map__somerset': '/media/owners/04-Somerset.jpg',
        'owners-cms-block-map__dorset': '/media/owners/05-Dorset.jpg',
        'owners-cms-block-map__hampshire': '/media/owners/06-Hampshire.jpg',
        'owners-cms-block-map__sussex': '/media/owners/09_Sussex_Kent.jpg',
        'owners-cms-block-map__isle-of-wight': '/media/owners/08-Isle-Of-Wight.jpg',
        'owners-cms-block-map__pembrokeshire': '/media/owners/09-pembrokeshire.jpg',
        'owners-cms-block-map__cotswolds': '/media/owners/03-Cotswolds.jpg'
    }

    Object.keys(regions).forEach((selector) => {
        const regionArea = document.getElementById(selector)
        const regionImage = regions[selector]

        new Helpers(regionArea).eventListener((e) => {
            imageEl.src = regionImage
        }, 'mouseover')

        new Helpers(regionArea).eventListener((e) => {
            imageEl.src = imageSrc
        }, 'mouseout')
    })
}
